import styled from '@emotion/styled'
import { css } from '@emotion/react'
import {
  InfoMedium500Style,
  InfoXXXSmall600Style,
} from '../../../../styles/Text.styles'
import theme from '../../../../styles/theme'

// Vertical stack container
export const GraphStack = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  gap: 1rem;
  justify-content: center;
`

// Simple version of WrapWithLineBetween without the complex positioning logic
export const SimpleInfoContainer = styled.div`
  background-color: ${theme.colors.backgroundLight};
  border-radius: 1rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  padding-top: 0rem;
  padding-bottom: 0rem;
`

// Simple version of LineCloseToMeElement
export const SimpleInfoItem = styled.div`
  width: 8.3rem;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
`

// New component for description items that spans full width
export const SimpleInfoDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
`

export const DescriptionFieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  padding: 0.5rem 0.2rem 0rem 0rem;
`

export const DescriptionTextStyle = styled.span`
  ${InfoXXXSmall600Style};
  padding-right: 0rem;
  min-width: 100px;
  margin-bottom: 0px;
  height: 1.2rem;
  line-height: 1.2rem;
  margin-right: 1.5rem;
`

export const decriptionInfoValueStyle = css`
  ${InfoMedium500Style};
  max-width: 50%;

  color: ${theme.colors.veryVeryVeryFadedText};
`
